<template>
  <div>
    <div class="app-container">
      <div style="height: 30px">
        <vxe-button class="filter-search-item" v-auth="`EXPORT`" @click="dialogVisibleFun">导出</vxe-button>
        <div style="float: right; color: #848484; display: flex; line-height: 28px">
          <div v-if="!showdiv">
            <a-input v-model="queryCondition.planCodeOrName" placeholder="输入活动名称/计划编码" clearable style="width: 200px; margin-right: 1rem" @keyup.enter.native="queryByPage(1)" />
          </div>
          <div>
            <vxe-button v-show="!showdiv" status="primary" class="filter-search-item" @click="queryByPage(1)">搜索</vxe-button>
            <vxe-button v-show="!showdiv" type="info" class="filter-search-item" @click="resetForm()">重置</vxe-button>
            <vxe-button type="warning" @click="cb">
              {{ showdiv ? '收起' : '筛选' }}
            </vxe-button>
          </div>
        </div>
      </div>
      <!--  高级筛选折叠-->
      <div style="margin-top: 10px">
        <a-collapse>
          <div v-show="showdiv">
            <SiftActivity :data="queryCondition" :show="false" />
            <br>
            <div slot="footer" style="text-align: center; padding-bottom: 10px">
              <vxe-button type="info" @click="resetForm">重置</vxe-button>
              <vxe-button status="primary" @click="queryByPage(1)">搜索</vxe-button>
            </div>
          </div>
        </a-collapse>
      </div>
      <vxe-toolbar ref="toolbarRef" custom style="height:39px;margin-top:-10px;background: #F3F4F7;width: 100%" />
      <vxe-table
        id="toolbar_applyActivityList"
        ref="xTable"
        :loading="listLoading"
        border
        show-header-overflow
        show-overflow
        align="center"
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        stripe
        round
        :custom-config="{storage: {visible: true, resizable: true },checkMethod: this.checkColumnMethod}"
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="tableData"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column field="planCode" title="活动计划编码" width="160" />
        <vxe-column :visible="false" title="经理部名称" field="sectorName" width="120" />
        <vxe-column :visible="false" title="经销商名称" field="dealerShortName" width="200" />
        <vxe-column field="actName" title="活动名称" width="160" />
        <vxe-column field="budgetTypeName" title="预算类型" width="160" />
        <!-- <vxe-column field="releaseTime" title="发布时间" width="150" /> -->
        <vxe-column field="oneLevelName" title="一级来源" width="160" />
        <vxe-column field="twoLevelName" title="二级来源" width="160" />
        <vxe-column field="threeLevelName" title="三级来源" width="160" />
        <!-- <vxe-column field="fourLevelName" title="四级来源" width="160" />
        <vxe-column field="fiveLevelName" title="五级来源" width="160" /> -->
        <vxe-column field="planStartTime" title="生效时间" width="120" />
        <vxe-column field="planEndTime" title="失效时间" width="120" />
        <vxe-column field="feeLimit" title="费用额度(元)" width="160" >
          <template #default="{ row }">
            {{ row.feeLimit | toThousandNumFilter }}
          </template>
        </vxe-column>
        <vxe-column field="writeRate" title="核销比例(%)" width="120" />
        <vxe-column field="executeFreq" title="执行频次" width="120" />
        <vxe-column field="remainFreq" title="剩余执行频次" width="120" />
        <!-- <vxe-column field="customerTarget" title="集客目标" width="120" />
        <vxe-column field="orderTarget" title="订单目标" width="120" />
        <vxe-column field="executeNums" title="执行数量" width="120" />
        <vxe-column field="closeTime" title="关闭时间" width="130" />
        <vxe-column field="remarks" title="活动其他说明" width="160" />
        <vxe-column field="writeOffRules" title="核销规则" width="160" />
        <vxe-column field="writeOffMaterial" title="核销材料说明" width="160" />
        <vxe-column field="writeOffOther" title="核销其他说明" width="160" /> -->
        <vxe-column field="createTime" title="创建时间" width="160" />
        <vxe-column field="createUserName" title="创建人" width="160" />
        <vxe-column title="操作" width="160" fixed="right" align="center">
          <template #default="{ row }">
            <div class="handle-box" style="height:30px">
               <!-- lr0013 -->
              <!-- <a-button v-auth="`APPEND`" type="link" @click="signSubmit(row, 1)">追加</a-button> -->
              <a-button v-auth="`APPLY`" type="link" @click="signSubmit(row, 0)">提报</a-button>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        v-show="!listLoading"
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />
    </div>
    <!-- 导出对话框 -->
    <a-modal title="选择导出项" v-model="dialogVisible" width="400px">
      <a-radio-group v-model="ExportItem">
        <a-radio :value="0">导出全部</a-radio>
        <a-radio :value="1">导出当前页</a-radio>
        <a-radio :value="2" :disabled="disabled">导出已选择项</a-radio>
      </a-radio-group>
      <span slot="footer" class="dialog-footer">
        <vxe-button size="small" @click="dialogVisible = false">取 消</vxe-button>
        <vxe-button size="small" status="primary" :loading="outExcelButtonLocading" @click="handleDownload">确 定</vxe-button>
      </span>
    </a-modal>
  </div>
</template>

<script>
import { findActsByDealer, exportActsByDealer } from '@/api/actPlan'
// import permission from '@/directive/permission/index.js' // 权限判断指令
import waves from '@/directive/waves'
import SiftActivity from './components/SiftActivity.vue'

const defaultQueryCondition = {
  planStatus: null, // 状态
  budgetTypeCode: null,
  oneLevelName: null,
  twoLevelName: null,
  threeLevelName: null,
  fourLevelName: null,
  fiveLevelName: null,
  planCodeOrName: null
}
export default {
  // inject: ['reload'],
  name: 'ApplyActivityList',
  directives: { waves },
  components: { SiftActivity },
  data() {
    return {
      dialogVisible: false, // 导出对话框
      outExcelButtonLocading: false, // 按钮等待
      ExportItem: 0, // 导出选择
      disabled: false, // 已选择是否导出
      tableData: [],
      domain: 'dealer', // center,表示总部; dealer，表示经销商
      userLevel: 20,
      listLoading: false,
      showdiv: false, // div显示或隐藏
      // 查询条件
      queryCondition: Object.assign({}, defaultQueryCondition),
      modelTable: {
        // 数据
        data: [],
        loading: false,
        selection: []
      },
      pagination: {
        // 分页
        total: 0,
        size: 20,
        current: 1,
        conditions: []
      },
      sort: 'release_time desc',
      hasRefreshed: false
    }
  },
  computed: {
    // queryCondition() {
    //   return this.$store.state.actPlanListPage.queryCondition
    // },
    // pagination() {
    //   return this.$store.state.actPlanListPage.pagination
    // }
  },
  watch: {
    $route(to, from) {
      console.log(to,from,'999999999999999999999');
      // if(from) window.location.reload(); //监测到路由发生跳转时刷新一次页面
      this.$router.push(to.fullPath)
    },
  },
  activated() {
    this.queryByPage() // 活动维护初始化数据
  },
  created() {
    if (this.$route.params) {
      this.queryCondition.planCodeOrName = this.$route.params.planCode
    }
    this.queryByPage() // 活动维护初始化数据
  },
  mounted() {
    this.$nextTick(() => {
      const $table = this.$refs.xTable
      const $toolbar = this.$refs.toolbarRef
      if ($table && $toolbar) {
        $table.connect($toolbar)
      }
    })
  },
  methods: {
    dialogVisibleFun() {
      if (this.domain === 'center') {
        this.$message.warning('导出失败，用户没有导出权限')
        return
      }
      this.ExportItem = 0
      this.disabled = this.$refs.xTable.selection.length < 1
      this.dialogVisible = true
    },
    // 新增跳转
    goAdd() {
      this.$router.push({ path: 'addActivity/null' })
    },
    allShowCollapse() {
      this.showdiv = !this.showdiv // div显示或隐藏
    },
    // 重置筛选
    resetForm() {
      this.queryCondition = { ...defaultQueryCondition }
      this.pagination = {
        current: 1,
        size: 20,
        total: 0
      }
      // this.sourceList.twoSourceList = this.defaultSourceList.twoSourceList
      // this.sourceList.threeSourceList = this.defaultSourceList.threeSourceList
      this.queryByPage(1)
    },
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      pageSize !== this.pagination.size && (this.pagination.current = 1)
      this.pagination.size = pageSize
      this.queryByPage()
    },
    cb() {
      this.showdiv = !this.showdiv
    },
    // 查询活动
    queryByPage(e) {
      if (e) this.pagination.current = e
      // 保存查询条件到store
      this.$store.commit('actPlanListPage/updatePagination', this.pagination)
      this.$store.commit('actPlanListPage/updateQueryCondition', this.queryCondition)

      const data = {
        page: this.pagination.current,
        limit: this.pagination.size,
        ...this.queryCondition,
        sort: this.sort
      }
      this.listLoading = true // 开启加载动画
      findActsByDealer(data).then(res => {
        if (res.code === 1) {
          this.pagination.total = res.data.total
          this.tableData = res.data.list
          this.listLoading = false
        } else {
          this.$message.error(res.message)
          this.listLoading = false
        }
      })
    },
    signSubmit(row, type) {
      // 获取当前日期
      const currentDate = new Date()
      const closeDate = new Date(row.closeTime)
      // 将时间部分设置为相同，这里将时间部分都设置为 00:00:00
      currentDate.setHours(0, 0, 0, 0)
      closeDate.setHours(0, 0, 0, 0)

      if (currentDate > closeDate && row.closeTime !== null) {
        this.$message.warning('活动计划已关闭，' + '当前时间' + currentDate.Format('yyyy-MM-DD') + '已超过该活动计划关闭时间' + closeDate.Format('yyyy-MM-DD'))
        return
      }
      this.$router.push({ path: `signActivity/${row.id}/${type}` })
    },
    // 选择数据
    selectionChange(val) {
      this.modelTable.selection = val
    },
    // 导出
    async handleDownload() {
      this.outExcelButtonLocading = true
      let param = {}
      if (this.ExportItem == 0) {
        if (this.pagination.total > 10000) {
          this.$message.warning('导入' + this.pagination.total + '条，过程可能持续数分钟。')
        }
        param = {
          page: 1,
          limit: this.pagination.total,
          sort: this.sort,
          ...this.queryCondition
        }
      } else if (this.ExportItem == 1) {
        param = {
          page: this.pagination.current,
          limit: this.pagination.size,
          sort: this.sort,
          ...this.queryCondition
        }
      } else if (this.ExportItem == 2) {
        const idList = []
        this.$refs.xTable.selection.forEach(item => {
          idList.push(item.id)
        })
        param = {
          page: 1,
          limit: this.pagination.size,
          ids: idList,
          sort: this.sort,
          ...this.queryCondition
        }
      }

      exportActsByDealer(param).then(val => {
        this.$exportExcelData(val, `可提报活动列表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
        this.dialogVisible = false
        this.outExcelButtonLocading = false
      })
    },
    sign(row, i) {
      this.$router.push({
        path: `signActivity/${row.actplanid}/${i}`
      })
    },
    qurryDeta(row) {
      this.$router.push({
        path: `detailsActivity/${row.id}`
      })
    },
    // 获取修改id
    editEvent(row) {
      this.$router.push({
        path: `editActivity/${row.id}`
      })
    },
    checkColumnMethod({ column }) {
      if (column.field === 'id') {
        return false
      }
      return true // 其他列允许显示/隐藏
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .ant-collapse {
  border: none;
  background-color: #fff;
}
</style>
